export const RECOMMENDATIONS_VALUE = 'RECOMMENDATIONS';

export const RECOMMENDATIONS_OPTION = {
  label: 'Sugerencias',
  value: RECOMMENDATIONS_VALUE
};

export const LIMIT_OF_ITEMS = 10_000;
